import React, {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import './AssetDetails.css';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import FromFieldText from '../../../atoms/FromFieldText';
import {getAllocation, getDepreciation, getSTPI} from '../../../services/asset.service';
import {getDepartmentList} from '../../../services/user.service';
import {DataGrid, GridToolbarContainer, GridToolbarExport} from '@mui/x-data-grid';
import FromFieldNumber from '../../../atoms/FromFieldNumber';
import * as CryptoJS from "crypto-js";
//var months = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
var months = {
    '1': 'JAN', '2': 'FEB', '3': 'MAR', '4': 'APR', '5': 'MAY', '6': 'JUN', '7': 'JUL',
    '8': 'AUG', '9': 'SEP', '10': 'OCT', '11': 'NOV', '12': 'DEC'
};
Date.prototype.dbFormatedDate = function () {

    let year = this.getFullYear();
    let month = this.getMonth() + 1;
    let day = this.getDate();
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    return year + '-' + month + '-' + day;
    //return `${this.getFullYear()}-${this.getMonth()+1}-${this.getDate()-1}`
}

function getFormatedDate(dateString) {
    if (dateString !== null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return year + '-' + month + '-' + day;
        //return `${dte.getFullYear()}-${dte.getMonth()+1}-${dte.getDate()}`;
    } else {
        return null;
    }
}

const columns = [
    {"field": "id", "hideable": true, "hide": true, "headerName": "Sl No"},
    {"field": "year", "hideable": true, "hide": true, "headerName": "Year"},
    {"field": "month", "hide": true, "headerName": "Month", valueGetter: (parms) => months[parms.row.month]},

    {"field": "tag", "hide": false, "headerName": "TAG", width: 250},
    {
        "field": "depreciation_date", "hide": false, "headerName": "Date", width: 150,
        renderCell: (params) => (
            <p>{params.value ? getFormatedDate(params.value) : ''}</p>
        )
    },

    {"field": "asset_ob", "hide": false, "headerName": "Asset OB"},
    {"field": "asset_added_value", "hide": false, "headerName": "Asset Added Value"},
    {"field": "asset_deleted_value", "hide": false, "headerName": "Asset Deleted Value"},
    {"field": "asset_cb", "hide": false, "headerName": "Asset CB"},

    {"field": "depreciation_ob", "hide": false, "headerName": "Depreciation OB"},
    {"field": "depreciation_added_value", "hide": false, "headerName": "Depreciation Added Value"},
    {"field": "depreciation_deleted_value", "hide": false, "headerName": "Depreciation Deleted Value"},
    {"field": "depreciation_adjusted_value", "hide": false, "headerName": "Depreciation Adjusted Value"},
    {"field": "depreciation_cb", "hide": false, "headerName": "Depreciation CB"},

    {"field": "wdv_ob", "hide": false, "headerName": "WDV OB"},
    {"field": "wdv_cb", "hide": false, "headerName": "WDV CB"}
];


function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarExport 
                csvOptions={{
                    fileName: 'consumable_asset_list',
                }}
            />
        </GridToolbarContainer>
    );
}

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{p: 3}}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function ConsumableAssetDetails() {
    const [value, setValue] = useState(0);
    const [tag, setTag] = useState(0);
    const [assetInfo, setAssetInfo] = useState(0);
    const [loading, setLoading] = useState(false);
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Tag = query.get('tag');
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [EncryptData1, setEncryptData1] = useState([]);
    useEffect(() => {
        if (Tag !== '' && Tag !== null) {

            const decryptedBytes = CryptoJS.AES.decrypt(Tag.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            // Convert the decrypted bytes to a string
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            const decryptedTagid = decrypt_data.tag;

            getTagAutoInfo(decryptedTagid);
            //alert(Tag);
        }
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            //'param_data':obj,
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = {'token': EncryptData}
        /*getRoleList(oData).then(res=>{
            if(res?.data?.data?.length) setRoles(res.data.data);
        });*/
        getDepartmentList(oData).then(res => {
            if (res?.data?.data?.length) setDepartments(res.data.data);
        });
    }, [])


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    var onCellEditStopFn = (event, newCell) => {
        var obj = {};
        obj[newCell.field] = event.target.value;
    }
    const getTagAutoInfo = function (Tag) {
        const decryptedBytes = CryptoJS.AES.decrypt(Tag.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
        setEncryptData1(decryptedBytes);
        let EncryptData1 = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': {'tag': Tag, 'module': 'Addition'},
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        //console.log(EncryptData1);
        //console.log("SKB2");
        
        let oData = {'token': EncryptData1}
        getSTPI(oData).then(function (res) {
            if (res?.data?.data) {
                setErrMsg('');
                var {assetInfo} = res.data.data;
                setAssetInfo(assetInfo);

            } else {
                setAssetInfo({});
                setErrMsg('Assets Not Found');
            }

        })
        try {
            setLoading('..');
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': {'tag': Tag},
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = {'token': EncryptData}
            getDepreciation(oData).then(function (res) {
                if (res.status === 200) {
                    var data = res?.data?.data;
                    if (data?.assetInfo && data?.assetDeprisiation) {
                        setAssetInfo(data.assetInfo);
                    } else {
                        setErrMsg('Assets Not Found');
                    }
                }
            });
            setLoading(false); // Stop loading
        } catch (err) {
            setLoading(false); // Stop loading 
            
        }
        try {
            setLoading('..');
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': {'tag': Tag},
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData1 = {'token': EncryptData}
            getAllocation(oData1).then(function (res) {

                var info = {};
                //getTransferData(tag).then(function(res){
                if (res?.data?.data?.assetInfo) {
                    info = res.data.data.transferInfo;
                    
                } else {
                    
                }
            });
            setLoading(false); // Stop loading
        } catch (err) {
            setLoading(false); // Stop loading in case of error
        }

    }
    const getTagInfo = function () {
        if (tag == '') {
            setErrMsg('Enter Assets');
        } else {
            setErrMsg('');
            try {
                setLoading('..');
                let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                    'param_data': {'tag': tag},
                    'authToken': sessionStorage.getItem('LoggedInToken'),
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

                let oData = {'token': EncryptData}
                getDepreciation(oData).then(function (res) {
                    if (res.status === 200) {
                        var data = res?.data?.data;
                        if (data?.assetInfo && data?.assetDeprisiation) {
                            setErrMsg('');
                            setAssetInfo(data.assetInfo);
                        } else {
                            setAssetInfo({});
                            setErrMsg('Assets Not Found');
                        }
                    }
                });
                setLoading(false); // Stop loading
            } catch (err) {
                setLoading(false); // Stop loading
            }
            try {
                setLoading('..');
                let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                    'param_data': {'tag': tag},
                    'authToken': sessionStorage.getItem('LoggedInToken'),
                }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

                let oData1 = {'token': EncryptData}
                getAllocation(oData1).then(function (res) {
                    var info = {};
                    //getTransferData(tag).then(function(res){
                    if (res?.data?.data?.assetInfo) {
                        info = res.data.data.transferInfo;
                    }
                });
                setLoading(false); // Stop loading
            } catch (err) {
                setLoading(false); // Stop loading in case of error
            }
        }
    }
    const sSub_Module_Id = sessionStorage.getItem('LoggedInSubModuleId');
    const aSub_Module_Id = sSub_Module_Id.split(',');
    //console.log('aSub_Module_Id'); console.log(aSub_Module_Id);
    return (
        <div className="container ">
            <h5></h5>
            {success ? (
                <div className="alert alert-success" role="alert"><i className="bi bi-check-circle-fill"></i>{success}
                </div>
            ) : (errMsg ? (<div className="alert alert-danger" role="alert"><i
                    className="bi bi-exclamation-triangle-fill"></i>{errMsg}</div>) : ('')
            )}
            { 
                (Tag !== '' && Tag !== null) ? <div className='row'>
                    <div className='col-8'></div>
                    <div className='col-4'>
                        <a href={'/single-asset?tag=' + Tag+'&back_url=consumable-asset-details'}>
                        <button className='btn btn-info'><i className="bi bi-pencil-square"></i> Edit</button>
                    </a>&nbsp;
                        <a href={'/all-consumable-asset-list'}>
                        <button className='btn btn-secondary'><i className="bi bi-arrow-left"></i> Back</button>
                    </a>&nbsp;</div>
                        </div> : <div className='row'>
                        <div className='col'><h5 className='align-right'>TAG </h5></div>
                        <div className='col'><input onChange={function (event) {
                        setTag(event.target.value)
                    }} inputValue={assetInfo.tag} type="text" className="form-control"
                                 placeholder='Enter the asset TAG'/></div>
                    <div className='col'>
                        <button onClick={getTagInfo} className='btn btn-info btn-sm'><i className="bi bi-search"></i> Search
                        </button>
                    </div>
                    {loading ? (<div className="spinner-border text-primary" role="status">
                        <span className="sr-only">{loading}</span>
                    </div>) : ('')}</div>
            }

<div className='row h-100'>

    <div className='col h-100'>
        <Box sx={{width: '100%'}}>
            <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Information" {...a11yProps(0)} />
                    
                </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
                <div className='row'>
                    <div className='col'><FromFieldText readOnly="readonly" label="TAG"
                                                        inputValue={assetInfo.tag}/></div>
                    <div className='col'><FromFieldText readOnly="readonly" label="Parent TAG"
                                                        inputValue={assetInfo.parent_tag}/></div>
                </div>
                <div className='row'>
                    <div className='col'><FromFieldText readOnly="readonly" label="Year of Addition"
                                                        inputValue={assetInfo.year_of_addition}/></div>
                    <div className='col'><FromFieldText readOnly="readonly" label="Type of Addition"
                                                        inputValue={assetInfo.type_of_addition}/></div>
                </div>
                <div className='row'>
                    <div className='col'><FromFieldText readOnly="readonly" label="Project Marking"
                                                        inputValue={assetInfo.project_marking}/></div>
                    <div className='col'><FromFieldText readOnly="readonly" label="PO No (If Any)"
                                                        inputValue={assetInfo.po_no}/></div>
                </div>
                <div className='row'>
                    <div className='col'><FromFieldText readOnly="readonly" label="Supplier Code (if Any)"
                                                        inputValue={assetInfo.supplier_code}/></div>
                    <div className='col'><FromFieldText readOnly="readonly" label="Name of the Supplier"
                                                        inputValue={assetInfo.supplier_name}/></div>
                </div>
                <div className='row'>
                    <div className='col'><FromFieldText readOnly="readonly" label="Invoice No"
                                                        inputValue={assetInfo.invoice_no}/></div>
                    <div className='col'><FromFieldText readOnly="readonly" label="Invoice Date"
                                                        inputValue={assetInfo.invoice_date ? getFormatedDate(assetInfo.invoice_date) : ''}/>
                    </div>
                </div>

                <div className='row'>
                    <div className='col'><FromFieldText readOnly="readonly" label="Bill of Entry No"
                                                        inputValue={assetInfo.boe_no}/></div>
                    <div className='col'><FromFieldText readOnly="readonly" label="Date of BOE"
                                                        inputValue={assetInfo.boe_date ? getFormatedDate(assetInfo.boe_date) : ''}/>
                    </div>
                </div>

                <div className='row'>
                    <div className='col'><FromFieldText readOnly="readonly" label="Shipping / AWB No"
                                                        inputValue={assetInfo.shipping_awb_no}/></div>
                    <div className='col'><FromFieldText readOnly="readonly" label="Date of Shipping/AWB"
                                                        inputValue={assetInfo.shipping_awb_date ? getFormatedDate(assetInfo.shipping_awb_date) : ''}/>
                    </div>
                </div>

                <div className='row'>
                    <div className='col'><FromFieldText readOnly="readonly" label="Accounting Voucher No."
                                                        inputValue={assetInfo.accounting_voucher_no}/></div>
                    <div className='col'><FromFieldText readOnly="readonly" label="Internal Approval No"
                                                        inputValue={assetInfo.internal_approval_no}/></div>
                </div>
                <div className='row'>
                    <div className='col'><FromFieldText readOnly="readonly" label="Cost Center Code"
                                                        inputValue={assetInfo.cost_center_code}/></div>
                    <div className='col'><FromFieldText readOnly="readonly" label="Cost Center Name"
                                                        inputValue={assetInfo.cost_center_name}/></div>
                </div>
                <div className='row'>
                    <div className='col'><FromFieldText readOnly="readonly" label="Invoice Currency"
                                                        inputValue={assetInfo.invoice_currency}/></div>
                    <div className='col'><FromFieldNumber readOnly="readonly" label="Exchange Rate"
                                                                      inputValue={parseFloat(assetInfo.exchange_rate).toFixed(2)}/></div>
                            </div>
                            <div className='row'>
                                <div className='col'><FromFieldNumber readOnly="readonly" label="Basic Cost p.u in Fx"
                                                                      inputValue={parseFloat(assetInfo.invoice_value_fx).toFixed(2)}/></div>
                                <div className='col'><FromFieldNumber readOnly="readonly" label="Basic Cost p.u in INR"
                                                                      inputValue={parseFloat(assetInfo.invoice_value_inr).toFixed(2)}/></div>
                            </div>
                            <div className='row'>
                                <div className='col'><FromFieldNumber readOnly="readonly"
                                                                      label="Forwarding & Insurance"
                                                                      inputValue={parseFloat(assetInfo.forwarding_and_insurance).toFixed(2)}/>
                                </div>
                                <div className='col'><FromFieldNumber readOnly="readonly" label="Installation"
                                                                      inputValue={parseFloat(assetInfo.installation).toFixed(2)}/></div>
                            </div>
                            <div className='row'>
                                <div className='col'><FromFieldNumber readOnly="readonly" label="Errection"
                                                                      inputValue={parseFloat(assetInfo.errection).toFixed(2)}/></div>
                                <div className='col'><FromFieldNumber readOnly="readonly"
                                                                      label="Total Cost Without Tax p.u"
                                                                      inputValue={parseFloat(assetInfo.total_cost_without_tax).toFixed(2)}/>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col'><FromFieldNumber readOnly="readonly" label="customs"
                                                                      inputValue={parseFloat(assetInfo.customs).toFixed(2)}/></div>
                                <div className='col'><FromFieldNumber readOnly="readonly" label="CGST"
                                                                      inputValue={parseFloat(assetInfo.cgst).toFixed(2)}/></div>
                            </div>
                            <div className='row'>
                                <div className='col'><FromFieldNumber readOnly="readonly" label="SGST"
                                                                      inputValue={parseFloat(assetInfo.sgst).toFixed(2)}/></div>
                                <div className='col'><FromFieldNumber readOnly="readonly" label="IGST"
                                                                      inputValue={parseFloat(assetInfo.igst).toFixed(2)}/></div>
                            </div>
                            <div className='row'>
                                <div className='col'><FromFieldNumber readOnly="readonly" label="Other Taxes"
                                                                      inputValue={parseFloat(assetInfo.other_taxes).toFixed(2)}/></div>
                                <div className='col'><FromFieldNumber readOnly="readonly" label="Total Tax p.u"
                                                                      inputValue={parseFloat(assetInfo.total_tax).toFixed(2)}/></div>
                            </div>

                            <div className='row'>
                                <div className='col'><FromFieldNumber readOnly="readonly"
                                                                      label="Total Cost with Tax p.u"
                                                                      inputValue={parseFloat(assetInfo.value_of_asset).toFixed(2)}/></div>
                                <div className='col'><FromFieldNumber readOnly="readonly" label="Qty"
                                                                      inputValue={parseFloat(assetInfo.qty).toFixed(2)}/></div>

                            </div>
                <div className='row'>
                    <div className='col'><FromFieldText readOnly="readonly" label="Unit Of Measure"
                                                        inputValue={assetInfo.unit_of_measure}/></div>
                    <div className='col'><FromFieldText readOnly="readonly"
                                                        label="Name of the Asset (as per Invoice)"
                                                        inputValue={assetInfo.asset_name}/></div>
                </div>
                <div className='row'>
                    <div className='col'><FromFieldText readOnly="readonly"
                                                        label="Detailed Description of the Asset"
                                                        inputValue={assetInfo.asset_description}/></div>
                    <div className='col'><FromFieldText readOnly="readonly" label="Nature of Presence"
                                                        inputValue={assetInfo.nature_of_presence}/></div>
                </div>
                <div className='row'>
                    <div className='col-6'><FromFieldText readOnly="readonly" label="Nature of Addition"
                                                          inputValue={assetInfo.nature_of_addition}/></div>
                    <div className='col'><FromFieldText readOnly="readonly"
                                                        label="Principal Asset to which Cost is Added"
                                                        inputValue={assetInfo.principal_asset_tag}/></div>
                </div>
                <div className='row'>
                    <div className='col'><FromFieldText readOnly="readonly"
                                                        label="Unique Sl No of the Asset"
                                                        inputValue={assetInfo.asset_serial_no}/></div>
                    <div className='col'><FromFieldText readOnly="readonly" label="Make / Manufacturer"
                                                        inputValue={assetInfo.manufacturer}/></div>
                </div>
                <div className='row'>
                    <div className='col'><FromFieldText readOnly="readonly" label="Model No"
                                                        inputValue={assetInfo.model_no}/></div>
                    <div className='col'><FromFieldText readOnly="readonly" label="Part No"
                                                        inputValue={assetInfo.part_no}/></div>
                </div>
                <div className='row'>
                    <div className='col'><FromFieldText readOnly="readonly" label="TAG"
                                                        inputValue={assetInfo.tag}/></div>
                    <div className='col'><FromFieldText readOnly="readonly" label="Comp Ref. No."
                                                        inputValue={assetInfo.comp_ref_no}/></div>
                </div>
                <div className='row'>
                    <div className='col-6'><FromFieldText readOnly="readonly" label="Asset TAG Name"
                                                          inputValue={assetInfo.tag_name}/></div>
                    <div className='col'><FromFieldText readOnly="readonly" label="Asset TAG Branch"
                                                        inputValue={assetInfo.tag_division}/></div>
                    <div className='col-6'></div>
                </div>
                <div className='row'>
                    <div className='col-6'><FromFieldText readOnly="readonly" label="Control Department"
                                                          inputValue={(departments && departments.length) > 0 ? (
                                                            departments
                                                                .filter(option => assetInfo.ownership_id === option.id)
                                                                .map(option => option.department_name)
                                                                .join(', ')
                                                        ) : ('')}/></div>
                    <div className='col'>
                        <FromFieldText readOnly="readonly" label="Security Seal Date"
                                       inputValue={assetInfo.security_seal_date ? getFormatedDate(assetInfo.security_seal_date) : ''}/>
                    </div>
                    <div className='col-6'></div>
                </div>
            </TabPanel>
            
        </Box>
    </div>
</div>
</div>
)
}

export default ConsumableAssetDetails